import React from 'react';
import Link from 'components/Link';
import Picture from 'components/Picture';
import { person as personPropType } from 'lib/CustomPropTypes';
import { sanitize } from 'lib/social';
import get from 'lodash.get';
import AIMS_FLAVORS from 'lib/aimsFlavors';

const getImage = (img, authorUrl) => {
  if (img) {
    const { altText, url: { primary: src } = {} } = img;
    const shouldLinkImage = !!authorUrl;
    return (
      <span
        data-test="article-byline__headshot"
        className="article-byline__image article-byline__image article-byline__image--has-image mr4 article-byline__headshot w3-print"
      >
        {
          shouldLinkImage
            ? (
              <a href={authorUrl}>
                <Picture
                  alt={altText}
                  url={src}
                  responsiveFlavors={{ s: AIMS_FLAVORS.FOCAL_100x100 }}
                />
              </a>
            )
            : (
              <Picture
                alt={altText}
                url={src}
                responsiveFlavors={{ s: AIMS_FLAVORS.FOCAL_100x100 }}
              />
            )
        }
      </span>
    );
  }
  return <span className="article-byline__image article-byline__image--no-image mt3 mv6-m mr4 mr0-print" data-test="article-byline__img" />;
};

const getName = (name, authorUrl) => {
  const shouldLinkName = !!authorUrl;
  return (
    <span
      className="article-byline__name article-byline__name founders-mono f3 lh-title ls-tight pt1 pt4-m ml9 ml0-m ml0-print"
    >
      {
        shouldLinkName
          ? (<a href={authorUrl}>{name}</a>)
          : (name)
      }
    </span>
  );
};

const getSocial = (social, email = null) => (
  <span
    className="article-byline__social f2 mt2 mt4-m ml9 ml0-m dn-print"
    data-test="article-byline__social"
  >
    {typeof social !== 'undefined' && social.twitter && (
      <Link
        href={`https://twitter.com/${sanitize(social.twitter)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => { event.stopPropagation(); }}
        className="article-byline__social-link"
      >
        <span className="icon icon-twitter" />
      </Link>
    )}
    {typeof social !== 'undefined' && social.facebook && (
      <Link
        href={`https://facebook.com/${sanitize(social.facebook)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => { event.stopPropagation(); }}
        className="article-byline__social-link"
      >
        <span className="icon icon-facebook" />
      </Link>
    )}
    {email && (
      <Link
        href={`mailto:${email.trim()}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => { event.stopPropagation(); }}
        className="article-byline__social-link"
      >
        <span className="icon icon-email" />
      </Link>
    )}
  </span>
);

const getBio = (bios) => bios.map((bio, index) => {
  if (bio && bio.type && bio.type === 'markup') {
    const key = `bio-${index}`;
    const {
      html,
      element: Element,
    } = bio;
    return (
      <Element
        key={key}
        dangerouslySetInnerHTML={{ __html: html }}
        className="article-byline__bio article-byline__bio publico-txt f2 lh-copy mt3 mt0-m ml9-m"
      />
    );
  }
  // TODO: are there other types?
  return null;
});

const Byline = ({ person }) => {
  const {
    name,
    email,
    bio,
    primaryImage: img,
    socialMediaProfiles: social,
  } = person;

  const authorUrl = get(person, ['url', 'primary'], undefined);

  return (
    <div className="article-byline pt3 pb2">
      <div className="article-byline__inner mt2 mt0-m">
        {getImage(img, authorUrl)}
        {getName(name, authorUrl)}
        {getSocial(social, email)}
      </div>
      {bio && getBio(bio)}
    </div>
  );
};

Byline.propTypes = {
  person: personPropType.isRequired,
};

Byline.defaultProps = {};

export default Byline;
